import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
function LeaderboardIndividualHeader({
  columnLabel,
  event,
  showSite,
  showTeam
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#F6F8FC",
    display: "flex",
    gap: 1,
    paddingX: 2,
    paddingY: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 30
  }), /*#__PURE__*/React.createElement(_Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, "Pseudo")), showSite && /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    overflow: "hidden",
    width: 120
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontWeight: 700,
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "body2"
  }, t('commons.challenge_details.table.site'))), showTeam && /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    overflow: "hidden",
    width: 120
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontWeight: 700,
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "body2"
  }, t('commons.challenge_details.table.team'))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 110
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "right",
    variant: "body2"
  }, columnLabel ?? t('commons.challenge_details.table.performance', {
    context: event.challengeTemplate?.type === 'bttf' || event.challengeTemplate?.type === 'custom' ? event.challengeTemplate.type : event.challengeTemplate?.type === 'traveledDistance' ? 'distance' : event.challengeTemplate?.type === 'cyclingDays' ? 'days' : event.challengeTemplate?.type === 'homeWorkJourneysCount' || event.challengeTemplate?.type === 'journeysCount' ? 'journeys' : ''
  }))));
}
export default LeaderboardIndividualHeader;